import { Button } from "antd";
import "./connectWallet.scss";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import React from "react";
import { sentryWalletBreadcrumb } from "@/lib/sentry";

interface Props {
  className?: string;
  style?: React.CSSProperties;
}

const ConnectWalletButton = ({ className, style }: Props) => {
  const { openConnectModal } = useConnectModal();

  const handleConnect = () => {
    sentryWalletBreadcrumb("connect_attempt");
    openConnectModal?.();
  };

  return (
    <Button
      className={`btn-connect-wallet ${className}`}
      style={style}
      onClick={handleConnect}
    >
      Connect Wallet
    </Button>
  );
};

export default ConnectWalletButton;
